const initialState = {
  serviceAreas: [],
  serviceArea: null,
  services: [],
  watercraft: [],
  wishlist: [],
  cart: [],
  productDetail: {},
  params: {},
  totalProducts: 0,
  selectedAccount: null
}

const accounts = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PRODUCTS':
      return { ...state, products: action.data.products, params: action.params, totalProducts: action.data.total }
    case 'GET_WISHLIST':
      return { ...state, wishlist: action.data.products }
    case 'DELETE_WISHLIST_ITEM':
      return { ...state }
    case 'GET_CART':
      return { ...state, cart: action.data.products }
    case 'DELETE_CART_ITEM':
      return { ...state }
    case 'ADD_TO_WISHLIST':
      return { ...state }
    case 'ADD_TO_CART':
      return { ...state }
    case 'GET_PRODUCT':
      return { ...state, productDetail: action.data.product }
    case 'GET_ACCOUNT':
      return { ...state, selectedAccount: action.selectedAccount }
    case 'GET_SERVICE_AREAS':
      return { ...state, serviceAreas: action.serviceAreas }
    case 'GET_SERVICE_AREA':
      return { ...state, serviceArea: action.serviceArea }
    case 'GET_SERVICES':
      return { ...state, services: action.services }
    case 'GET_WATERCRAFT':
      return { ...state, watercraft: action.watercraft }
    default:
      return state
  }
}

export default accounts
